import Skeleton from "@/components/Skeleton/Skeleton";
import { Col, Form, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import styles from "./ImpactReferenceDetails.module.scss";

export default function DatasetDetails({
  isLoading,
  title,
  description,
  isCustom,
}: {
  isLoading: boolean;
  title: string;
  description: string;
  isCustom?: boolean;
}) {
  return (
    <>
      <div className={styles.row}>
        <h2>Details</h2>
      </div>
      <div className={styles.row}>
        <Form.Item
          label={"Name"}
          name={"name"}
          labelCol={{ span: 24 }}
          rules={[
            {
              required: true,
              message: `Name is required.`,
            },
          ]}
          style={{ marginBottom: 0 }}
        >
          {isLoading ? (
            <Skeleton
              loading={isLoading}
              style={{ width: 220, height: 14 }}
            ></Skeleton>
          ) : (
            <Input autoComplete={"off"} />
          )}
        </Form.Item>
      </div>
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Form.Item
            label={"Unit"}
            name={"unit"}
            labelCol={{ span: 24 }}
            style={{ marginBottom: 0 }}
            rules={[
              {
                required: true,
                message: `Unit is required.`,
              },
            ]}
          >
            {isLoading ? (
              <Skeleton
                loading={isLoading}
                style={{ width: 100, height: 14 }}
              ></Skeleton>
            ) : (
              <Input autoComplete={"off"} />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={"Geography"}
            name={"geography"}
            labelCol={{ span: 24 }}
            style={{ marginBottom: 0 }}
          >
            {isLoading ? (
              <Skeleton
                loading={isLoading}
                style={{ width: 100, height: 14 }}
              ></Skeleton>
            ) : (
              <Input autoComplete={"off"} />
            )}
          </Form.Item>
        </Col>
      </Row>
      {isCustom && (
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form.Item
              label={"Note"}
              name={"note"}
              labelCol={{ span: 24 }}
              style={{ marginBottom: 0 }}
            >
              {isLoading ? (
                <Skeleton
                  loading={isLoading}
                  style={{ width: 100, height: 14 }}
                ></Skeleton>
              ) : (
                <TextArea autoComplete={"off"} />
              )}
            </Form.Item>
          </Col>
        </Row>
      )}
      <div className={styles.epdBannerRow}>
        <Row>
          <Col
            span={24}
            className={styles.epdBannerHeading}
          >
            {title}
          </Col>
          <Col span={24}>{description}</Col>
        </Row>
      </div>
    </>
  );
}
